import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ViewType from "~/@types/viewType";
import { ContainerConfigSummaryFragment } from "~/gql/queries/restock/loadList.generated";

interface ContainersState {
	containerFormModalOpen: boolean;
	selectedContainer: ContainerConfigSummaryFragment | null;
	viewType: ViewType;
}

const initialState: ContainersState = {
	containerFormModalOpen: false,
	selectedContainer: null,
	viewType: "grid"
};

const containersSlice = createSlice({
	initialState,
	name: "restockContainers",
	reducers: {
		closeContainerFormModal: (state) => {
			state.containerFormModalOpen = false;
		},
		openContainerFormModal: (state) => {
			state.containerFormModalOpen = true;
		},
		setSelectedContainer: (state, action: PayloadAction<ContainerConfigSummaryFragment | null>) => {
			state.selectedContainer = action.payload;
		},
		setViewType: (state, action: PayloadAction<ViewType>) => {
			state.viewType = action.payload;
		}
	}
});

export const { closeContainerFormModal, openContainerFormModal, setSelectedContainer, setViewType } =
	containersSlice.actions;

export default containersSlice.reducer;
